import { createAction } from 'redux-actions';
export var markEditorFocused = createAction('DA_EDITOR.MARK_FOCUSED', function (editorKey) { return ({ editorKey: editorKey }); });
export var markEditorInactive = createAction('DA_EDITOR.MARK_INACTIVE', function (editorKey) { return ({ editorKey: editorKey }); });
// TODO: use action key constant
export var saveEditorDraft = createAction('DA_EDITOR.SAVE_EDITOR_DRAFT', function (editorId, editorState) { return ({
    editorId: editorId,
    editorState: editorState,
}); });
export var removeEditorDraft = createAction('DA_EDITOR.REMOVE_EDITOR_DRAFT', function (editorId) { return ({ editorId: editorId }); });
export var uploadDraggedFile = createAction('DA_EDITOR.UPLOAD_DRAGGED_FILE', function (file, uploadHelpers) { return ({ file: file, uploadHelpers: uploadHelpers }); });
//# sourceMappingURL=actionCreators.js.map